import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Phone } from "lucide-react";
import { COMPANY } from "@/content/site";

export default function CallFab() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.a
          href={COMPANY.phoneHref}
          data-testid="floating-call-button"
          aria-label={`Llamar al ${COMPANY.phone}`}
          className="fixed bottom-5 right-5 z-40 grid h-14 w-14 place-items-center rounded-full bg-[#B8955F] text-[#1E2228] shadow-[0_14px_30px_-10px_rgba(30,34,40,0.6)] md:hidden"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0, opacity: 0 }}
        >
          <Phone className="h-5 w-5" />
        </motion.a>
      )}
    </AnimatePresence>
  );
}
